import PropTypes from 'prop-types';
import Icon from '@jd/jmtd/es/Icon';
import React from 'react';
import classNames from '@jd/jmtd-tools/es/classnames';
export default function SummaryCardDescription(_ref) {
  var left = _ref.left,
      right = _ref.right,
      ascend = _ref.ascend,
      descend = _ref.descend,
      inverse = _ref.inverse,
      inverseColor = _ref.inverseColor;
  return /*#__PURE__*/React.createElement("div", {
    className: "jmtp-summary-card-description"
  }, /*#__PURE__*/React.createElement("div", {
    className: "jmtp-summary-card-description-left"
  }, left), /*#__PURE__*/React.createElement("div", {
    className: "jmtp-summary-card-description-right"
  }, right), ascend && /*#__PURE__*/React.createElement(Icon, {
    className: classNames("".concat(inverse ? 'jmti-arrow-down' : 'jmti-arrow-up'), "".concat(inverseColor ? 'jmtp-summary-card-arrow-red' : 'jmtp-summary-card-arrow-green'))
  }), descend && /*#__PURE__*/React.createElement(Icon, {
    className: classNames("".concat(inverse ? 'jmti-arrow-up' : 'jmti-arrow-down'), "".concat(inverseColor ? 'jmtp-summary-card-arrow-green' : 'jmtp-summary-card-arrow-red'))
  }));
}
SummaryCardDescription.propTypes = {
  left: PropTypes.node,
  right: PropTypes.node,
  ascend: PropTypes.bool,
  descend: PropTypes.bool,
  inverse: PropTypes.bool,
  inverseColor: PropTypes.bool
};
SummaryCardDescription.defaultProps = {
  left: null,
  right: null,
  ascend: false,
  descend: false,
  inverse: false,
  inverseColor: false
};